import React from 'react';

import introductionImage from '../../../../Assets/Linkages/WorldSpaceWeek/World-Space-Week-Introduction.png';

const WorldSpaceWeekIntroduction = () => (
  <section className="world-space-week-introduction" aria-labelledby="world-space-week-introduction-title">
    <div className="world-space-week-introduction-inner">
      <div className="world-space-week-introduction-copy">
        <p className="section-eyebrow">A GLOBAL CELEBRATION OF SPACE</p>
        <h1 id="world-space-week-introduction-title">Introduction</h1>
        <div className="world-space-week-title-line" aria-hidden="true" />

        <p>
          World Space Week (WSW), held every year from 4–10 October, is the world&apos;s largest
          celebration of space science, technology, and their impact on society. Declared by the
          United Nations General Assembly, it commemorates two historic milestones: the launch of
          Sputnik 1 on October 4, 1957, and the signing of the Outer Space Treaty on October 10,
          1967. Globally coordinated by the World Space Week Association (WSWA), WSW is celebrated
          in over 96 countries through events led by space agencies, schools, universities,
          planetariums, museums, and astronomy clubs.
        </p>

        <p>
          In Pakistan, World Space Week is led by SUPARCO, while the National Center of GIS and
          Space Applications (NCGSA) and the Institute of Space Technology, Islamabad actively
          contribute to this global celebration by organizing nationwide activities to inspire
          young minds, engage educators, and promote public awareness about the vast possibilities
          space science and technology offer for our future.
        </p>
      </div>

      <figure className="world-space-week-introduction-image">
        <img src={introductionImage} alt="World Space Week activities at NCGSA" />
      </figure>
    </div>
  </section>
);

export default WorldSpaceWeekIntroduction;
